export default function ChartCard({ title, children }) {
  return <article className="chart-card"><small>RESUMEN FINANCIERO</small><h2>{title}</h2>{children}</article>;
}